import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import TIM from 'tim-js-sdk';
import COS from 'cos-js-sdk-v5';
import moment from 'moment';
import { Component, Vue } from 'vue-property-decorator';
import { importAccount, indexLoad, validateStatus, custerInfo, queryMessageRecordDetail, validateInputStatus, productInfo } from '@/services/http';
import bigImg from '@/components/big-img/big-img.vue';
import { emojiList, emojis, uncodeUtf16, utf16toEntities } from '@/emoji/index';
import { readCookie } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.changeIm = false;
    _this.tim = {};
    _this.robotObj = {};
    _this.scrollHeight = '';
    _this.currentId = -1;
    _this.imgSrc = '';
    _this.newTime = 0; // 最新时间
    _this.newSequence = 0; // 最新时间
    _this.isOnce = 0;
    _this.userInfo = {}; // 用户信息
    _this.noMore = false; // 历史记录没有更多
    _this.lastEditRange = 0; // 聊天框最后光标位置
    _this.message = '';
    _this.openEmojis = false; // 打开表情
    _this.isOver = false; // 是否可发送
    _this.flagNum = 0;
    _this.emojiList = emojiList(); // 所有表情库
    _this.emojis = emojis(); // 去重后的表情库
    _this.conversationInfo = {}; // 当前会话信息
    _this.messageList = []; // 消息列表
    _this.robot = ''; // 机器人
    _this.custerInfo = {}; // 客服信息
    _this.nextReqMessageID = ''; // 用于腾讯IM续拉，分页续拉时需传入该字段
    _this.isMoreMessage = true; // 是否有更多当前消息
    _this.openHistory = false; // 是否打开历史记录
    _this.loading = true; // 是否加载完
    _this.isCoding = false; // 是否加载完
    _this.goodsInfo = {}; // 是否加载完
    _this.showImg = false; //
    _this.currentPage = 0; // 当前页数
    _this.currentLen = 0; // 当前长度
    _this.ready = false;
    _this.isSearch = false;
    _this.isDrop = false; // 移动状态的判断鼠标按下才能移动
    _this.listQuery = {
      pageNo: 1,
      pageSize: 15,
      keyword: '',
      companyId: 1
    };
    _this.historyList = [];
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      ;
      window.openUrl = function (url) {
        window.open(url, '_blank');
      };
      this.$emit('passpicker', this);
      // this.initData();
    }
  }, {
    key: "replaceSrc",
    value: function replaceSrc(txt) {
      if (txt.indexOf('<img') !== -1) {
        return txt;
      }
      var reg = /(((https?:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/gi;
      var result = txt.replace(reg, function (item) {
        return "<span onclick=\"openUrl('".concat(item, "')\" style=\"color:#0074F0;cursor:pointer;\">").concat(item, "</span>");
      });
      return result;
    }
  }, {
    key: "initData",
    value: function initData() {
      var _this2 = this;
      if (this.$route.name === 'details') {
        productInfo({
          productId: this.$route.query.id
        }).then(function (res) {
          _this2.goodsInfo = res.data.data;
          _this2.getImportAccount();
        });
      } else {
        this.getImportAccount();
      }
      this.openDrod();
    }
    // 开始监听拖拽
  }, {
    key: "openDrod",
    value: function openDrod() {
      var _this3 = this;
      setTimeout(function () {
        var box = document.querySelectorAll('.im .drop-header'); // 获取元素
        var x = '';
        var y = ''; // 存储div的坐标
        box.forEach(function (element) {
          element.addEventListener('mousedown', function (e) {
            // eslint-disable-next-line no-var
            var e1 = e || window.event; // 要用event这个对象来获取鼠标的位置
            x = e1.clientX - element.parentNode.parentNode.offsetLeft;
            y = e1.clientY - element.parentNode.parentNode.offsetTop;
            _this3.isDrop = true; // 设为true表示可以移动
          });
          document.onmousemove = function (e) {
            // 是否为可移动状态
            if (_this3.isDrop) {
              var e1 = e || window.event;
              var moveX = e1.clientX - x; // 得到距离左边移动距离
              var moveY = e1.clientY - y; // 得到距离上边移动距离
              // eslint-disable-next-line no-param-reassign
              element.parentNode.parentNode.style.left = "".concat(moveX, "px");
              // eslint-disable-next-line no-param-reassign
              element.parentNode.parentNode.style.top = "".concat(moveY, "px");
              // eslint-disable-next-line no-param-reassign
              element.parentNode.parentNode.style.right = 'auto';
            }
          };
          document.onmouseup = function () {
            _this3.isDrop = false; // 设置为false不可移动
          };
        });
      }, 0);
    }
  }, {
    key: "emojisBlur",
    value: function emojisBlur() {
      var _this4 = this;
      setTimeout(function () {
        _this4.openEmojis = false;
        _this4.$refs.emojisFocus.blur();
      }, 200);
    }
    // 发送给机器人
  }, {
    key: "sendRobot",
    value: function sendRobot(item) {
      var _this5 = this;
      var initMessage = this.tim.createCustomMessage({
        to: this.conversationInfo.userProfile.userID,
        conversationType: TIM.TYPES.CONV_C2C,
        payload: {
          data: JSON.stringify({
            itemType: 0,
            itemData: [{
              itemId: item.itemId,
              itemTitle: item.itemTitle,
              itemValue: item.itemValue
            }],
            itemText: ''
          }),
          description: '',
          extension: ''
        }
      });
      // 2. 发送消息
      var promise = this.tim.sendMessage(initMessage);
      promise.then(function (imResponse) {
        // eslint-disable-next-line no-param-reassign
        imResponse.data.message.payload.text = item.itemTitle;
        _this5.messageList.push(imResponse.data.message); // 更新消息列表
        _this5.message = '';
        _this5.$nextTick(function () {
          ;
          _this5.$refs.content.scrollTop = _this5.$refs.content.scrollHeight - _this5.$refs.content.clientHeight; // 滚动条位置设置在底部
        });
      }).catch(function () {}); // 发送失败
    }
    // 清除搜索文字
  }, {
    key: "clearSearch",
    value: function clearSearch() {
      this.listQuery.keyword = '';
      this.listQuery.pageNo = 1;
      this.isSearch = false;
      // (this.$refs.historyContent as any).scrollTop = 0;
      this.getHistory();
    }
    // 点击搜索
  }, {
    key: "btnSearch",
    value: function btnSearch() {
      if (this.listQuery.keyword.length <= 0) {
        this.isSearch = false;
      } else {
        this.isSearch = true;
      }
      this.listQuery.pageNo = 1;
      this.historyList = [];
      // (this as any).$refs.historyContent.scrollTop = 0;
      this.getHistory();
    }
  }, {
    key: "openEmojisDia",
    value: function openEmojisDia() {
      if (!this.isOver) {
        this.openEmojis = !this.openEmojis;
        if (this.openEmojis) {
          ;
          this.$refs.emojisFocus.focus();
        }
      }
    }
  }, {
    key: "viewImg",
    value: function viewImg() {
      this.showImg = false;
    }
    // 打开历史记录
  }, {
    key: "openSelfHistory",
    value: function openSelfHistory() {
      // document.body.clientWidth
      this.isSearch = false;
      this.openHistory = !this.openHistory;
      if (this.openHistory) {
        var imBox = document.querySelector('.im');
        // eslint-disable-next-line radix
        if (document.body.clientWidth - parseInt(imBox.style.left) < 986) {
          imBox.style.left = "".concat(document.body.clientWidth - 986, "px");
        }
      }
      if (this.openHistory) {
        this.listQuery.pageNo = 1;
        // (this as any).$refs.historyContent.scrollTop = 0;
        this.getHistory();
      }
    }
    // 获取历史记录
  }, {
    key: "getHistory",
    value: function getHistory() {
      var _this6 = this;
      this.loading = true;
      queryMessageRecordDetail(this.listQuery).then(function (res) {
        var tempData = [];
        if (_this6.isSearch) {
          tempData = _this6.formatHistoryList(res.data.data.list, 'unshift');
        } else {
          tempData = _this6.formatHistoryList(res.data.data.list, 'push');
        }
        if (_this6.listQuery.pageNo === 1) {
          _this6.historyList = tempData;
        } else if (!_this6.isSearch) {
          _this6.historyList = [].concat(_toConsumableArray(tempData), _toConsumableArray(_this6.historyList));
        } else {
          _this6.historyList = [].concat(_toConsumableArray(_this6.historyList), _toConsumableArray(tempData));
        }
        if (res.data.data.list.length <= 0) {
          _this6.noMore = true;
        }
        setTimeout(function () {
          var timPics = document.querySelectorAll('.tim-pic');
          timPics.forEach(function (element) {
            // eslint-disable-next-line no-shadow
            if (element.getAttribute('islazy') === '1') {
              element.setAttribute('src', element.getAttribute('z-src'));
            }
            element.addEventListener('click', function (e) {
              _this6.showImg = true;
              // eslint-disable-next-line prefer-destructuring
              _this6.imgSrc = e.currentTarget.src.split('?imageView')[0];
            });
          });
        }, 0);
        setTimeout(function () {
          if (_this6.$refs.historyContent) {
            if (_this6.listQuery.pageNo === 1 && !_this6.isSearch) {
              ;
              _this6.$refs.historyContent.scrollTop = _this6.$refs.historyContent.clientHeight + _this6.$refs.historyContent.scrollHeight; // 滚动条位置设置在底部
            } else {
              // eslint-disable-next-line no-lonely-if
              if (_this6.historyList.length > _this6.listQuery.pageSize) {
                ;
                _this6.$refs.historyContent.scrollTop = _this6.$refs.historyContent.clientHeight;
              } else {
                ;
                _this6.$refs.historyContent.scrollTop = 0;
              } // 滚动条位置设置在底部
            }
          }
          _this6.loading = false;
          _this6.listQuery.pageNo += 1;
        }, 200);
      });
    }
  }, {
    key: "openInput",
    value: function openInput() {
      if (!this.isOver) {
        ;
        this.$refs.imagePic.click();
      }
    }
    // 2. 创建消息实例，接口返回的实例可以上屏
  }, {
    key: "consultGoods",
    value: function consultGoods() {
      var _this7 = this;
      var message = this.tim.createCustomMessage({
        to: this.conversationInfo.userProfile.userID,
        conversationType: TIM.TYPES.CONV_C2C,
        // 消息优先级，用于群聊（v2.4.2起支持）。如果某个群的消息超过了频率限制，后台会优先下发高优先级的消息，详细请参考：https://cloud.tencent.com/document/product/269/3663#.E6.B6.88.E6.81.AF.E4.BC.98.E5.85.88.E7.BA.A7.E4.B8.8E.E9.A2.91.E7.8E.87.E6.8E.A7.E5.88.B6)
        // 支持的枚举值：TIM.TYPES.MSG_PRIORITY_HIGH, TIM.TYPES.MSG_PRIORITY_NORMAL（默认）, TIM.TYPES.MSG_PRIORITY_LOW, TIM.TYPES.MSG_PRIORITY_LOWEST
        // priority: TIM.TYPES.MSG_PRIORITY_HIGH,
        payload: {
          data: JSON.stringify({
            name: this.goodsInfo.productName,
            url: this.goodsInfo.listImagePath.cdnFilePathPc,
            price: this.goodsInfo.lowestPrice.split(',')[0] === this.goodsInfo.lowestPrice.split(',')[1] ? this.goodsInfo.lowestPrice.split(',')[0] : this.goodsInfo.lowestPrice,
            id: this.$route.query.id
          }),
          description: 'goodsInfo',
          extension: ''
        }
      });
      // 3. 发送消息
      var promise = this.tim.sendMessage(message);
      promise.then(function (imResponse) {
        // 发送成功
        // eslint-disable-next-line no-param-reassign
        imResponse.data.message.type = 'goodsInfo';
        // eslint-disable-next-line no-param-reassign
        imResponse.data.message.payload = JSON.parse(imResponse.data.message.payload.data);
        _this7.messageList.push(imResponse.data.message); // 更新消息列表
        _this7.$nextTick(function () {
          ;
          _this7.$refs.content.scrollTop = _this7.$refs.content.scrollHeight - _this7.$refs.content.clientHeight; // 滚动条位置设置在底部
        });
      }).catch(function () {
        // 发送失败
      });
    }
  }, {
    key: "historyLoad",
    value: function historyLoad() {
      if (this.isDrop) {
        return;
      }
      var scrollHeight = this.$refs.historyContent.scrollHeight;
      var scrollTop = this.$refs.historyContent.scrollTop;
      var clientHeight = this.$refs.historyContent.clientHeight;
      if (scrollHeight === scrollTop + clientHeight && !this.loading && this.isSearch && this.historyList.length >= 10) {
        this.getHistory();
      } else if (scrollTop === 0 && !this.loading && !this.isSearch && this.historyList.length >= 10) {
        this.getHistory();
      }
    }
    // 选择表情
  }, {
    key: "selectEmojis",
    value: function selectEmojis(item) {
      this.openEmojis = false;
      var html = "<img class=\"emoji-img\" src=\"".concat(item.src, "\" data-src=\"emoji\" emoji-text=\"").concat(item.text, "\">");
      if (this.$refs.message.innerHTML === '') {
        // (this.$refs.message as any).innerHTML = html;
        this.isCoding = true;
        this.setRange(html);
      } else this.setRange(html); // 表情插到输入框最后一次焦点后面
    }
  }, {
    key: "initTim",
    value: function initTim() {
      var options = {
        SDKAppID: process.env.VUE_APP_BASE_URL === 'https://mapi.ctaiot.com' ? 1400386549 : 1400428151
      };
      // 创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
      var tim = TIM.create(options); // SDK 实例通常用 tim 表示
      // 设置 SDK 日志输出级别，详细分级请参见 setLogLevel 接口的说明
      tim.setLogLevel(1); // 普通级别，日志量较多，接入时建议使用
      // tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用
      // 收到离线消息和会话列表同步完毕通知，接入侧可以调用 sendMessage 等需要鉴权的接口
      tim.on(TIM.EVENT.SDK_READY, this.SDK_READY);
      // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
      tim.on(TIM.EVENT.MESSAGE_RECEIVED, this.MESSAGE_RECEIVED);
      // 收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面
      tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, this.CONVERSATION_LIST_UPDATED);
      // 注册 COS SDK 插件
      tim.registerPlugin({
        'cos-js-sdk': COS
      });
      return tim;
    }
    // // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
    // MESSAGE_RECEIVED(event: any) {
    //   const receiveMessage = event.data.map(async (item: any) => {
    //     // 格式化自定义消息
    //     const mes: any = event.data[0];
    //     if (mes.conversationID === 'C2Cadmin') {
    //       this.currentPage = 0;
    //       if (mes.payload.data) {
    //         const text = JSON.parse(mes.payload.data);
    //         mes.payload = { text: text.itemText };
    //         mes.flow = 'status';
    //         if (text.itemType === 4 || text.itemType === 5) {
    //           // 会话已被客服接起
    //           this.custerInfo.conversationID = `C2C${text.itemData[0].itemId}`;
    //           // this.custerInfo.custNickName = text.itemData[0].custNickName;
    //           // this.custerInfo.custHeadImg = text.itemData[0].custImg;
    //           this.conversationInfo = {
    //             conversationID: `C2C${text.itemData[0].itemId}`,
    //             userProfile: { userID: text.itemData[0].itemId }
    //           };
    //           await this.getCusterInfo();
    //           this.getMessageList();
    //           this.isOver = false;
    //           // this.currentPage = 0;
    //         }
    //       }
    //     } else if (item.type === 'TIMCustomElem') {
    //       // 格式化自定义消息
    //       // eslint-disable-next-line no-param-reassign
    //       // item.payload = { text: text.itemText };
    //       // eslint-disable-next-line no-param-reassign
    //       item.flow = 'status';
    //       if (item.payload.data) {
    //         const text = JSON.parse(item.payload.data);
    //         if (text.itemType && text.itemType === 6) {
    //           this.outLogin(); this.isOver = true;
    //         } else if (text.itemType && text.itemType === 5) {
    //           this.messageList = [];
    //         }
    //         // eslint-disable-next-line no-param-reassign
    //         item.payload = { text: text.itemText };
    //       }
    //     } else if (item.type === 'TIMImageElem') {
    //       // 格式化图片消息
    //       const url = item.payload.imageInfoArray[0].imageUrl.split(
    //         '?imageView'
    //       )[0];
    //         // eslint-disable-next-line no-param-reassign
    //       item.payload = { text: `<img class="tim-pic" z-src="${url}" islazy="1" src="${require('@/assets/images/default-img.png')}">` };
    //     } else if (item.type !== 'TIMImageElem') {
    //       // 解析表情转本地库表情
    //       for (let j = 0; j < this.emojiList.length; j += 1) {
    //         const reg = new RegExp(this.emojiList[j].code, 'g');
    //         // eslint-disable-next-line no-param-reassign
    //         item.payload.text = utf16toEntities(item.payload.text).replace(
    //           reg,
    //           `<img class="emoji-img" src="${this.emojiList[j].src}">`
    //         );
    //       }
    //     }
    //     return item;
    //   })[0];
    //   this.messageList.push(receiveMessage);
    //   setTimeout(() => {
    //     const timPics = document.querySelectorAll('.tim-pic');
    //     timPics.forEach((element:any) => {
    //       // eslint-disable-next-line no-shadow
    //       if (element.getAttribute('islazy') === '1') {
    //         element.setAttribute('src', element.getAttribute('z-src'));
    //       }
    //       element.addEventListener('click', (e:any) => {
    //         this.showImg = true;
    //         // eslint-disable-next-line prefer-destructuring
    //         this.imgSrc = e.currentTarget.src.split('?imageView')[0];
    //       });
    //     });
    //   }, 0);
    //   this.$nextTick(() => {
    //     setTimeout(() => {
    //       if ((this as any).$refs.content) {
    //         (this as any).$refs.content.scrollTop = (this as any).$refs.content.scrollHeight
    //           - (this as any).$refs.content.clientHeight; // 滚动条位置设置在底部
    //       }
    //     }, 200);
    //     this.tim.setMessageRead({
    //       conversationID: this.conversationInfo.conversationID
    //     });
    //   });
    // }
    // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
  }, {
    key: "MESSAGE_RECEIVED",
    value: function () {
      var _MESSAGE_RECEIVED = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(event) {
        var _this8 = this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              event.data.forEach(/*#__PURE__*/function () {
                var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(mes) {
                  var text, temp, url, j, reg, goodsData;
                  return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        if (!(_this8.newTime === mes.time && mes.sequence === _this8.newSequence)) {
                          _context.next = 2;
                          break;
                        }
                        return _context.abrupt("return");
                      case 2:
                        _this8.newTime = mes.time;
                        _this8.newSequence = mes.sequence;
                        if (!(mes.conversationID === 'C2Cadmin' || mes.conversationID === 'C2CmallAdmin')) {
                          _context.next = 26;
                          break;
                        }
                        _this8.currentPage = 0;
                        if (!mes.payload.data) {
                          _context.next = 24;
                          break;
                        }
                        text = JSON.parse(mes.payload.data);
                        if (!(text.itemType === 1 || text.itemType === 0)) {
                          _context.next = 13;
                          break;
                        }
                        temp = JSON.parse(mes.payload.data);
                        _this8.messageList.push({
                          flow: 'in',
                          payload: {
                            text: temp.itemData[0].itemValue
                          }
                        });
                        _context.next = 24;
                        break;
                      case 13:
                        if (!(text.itemType === 4 || text.itemType === 5)) {
                          _context.next = 23;
                          break;
                        }
                        // 会话已被客服接起
                        _this8.custerInfo.conversationID = "C2C".concat(text.itemData[0].itemId);
                        // this.custerInfo.custNickName = text.itemData[0].custNickName;
                        // this.custerInfo.custHeadImg = text.itemData[0].custImg;
                        _this8.changeIm = true;
                        _this8.conversationInfo = {
                          conversationID: "C2C".concat(text.itemData[0].itemId),
                          userProfile: {
                            userID: text.itemData[0].itemId
                          }
                        };
                        _context.next = 19;
                        return _this8.getCusterInfo();
                      case 19:
                        _this8.getMessageList(text.itemType === 5);
                        _this8.isOver = false;
                        // this.currentPage = 0;
                        _context.next = 24;
                        break;
                      case 23:
                        if (text.itemType === -1) {
                          // this.robotObj = {
                          //   payload: text,
                          //   type: -1,
                          //   flow: 'in'
                          // };
                        } else if (text.itemType === 7 || text.itemType === 6) {
                          // eslint-disable-next-line no-param-reassign
                          mes.payload = {
                            text: text.itemText
                          };
                          // eslint-disable-next-line no-param-reassign
                          mes.flow = 'status';
                          _this8.isOver = true;
                          _this8.messageList = [];
                          _this8.messageList.push(mes);
                        }
                      case 24:
                        _context.next = 31;
                        break;
                      case 26:
                        // const res: any = await validateStatus(); // 是否在会话中
                        // if (
                        //   res
                        //   && res.data
                        //   && res.data.code === 100
                        //   && !res.data.data.messageStatus
                        // ) {
                        //   // 在会话中，获取客服信息
                        //   this.conversationInfo.conversationID = `C2C${res.data.data.custAccount}`;
                        //   this.custerInfo.conversationID = `C2C${res.data.data.custAccount}`;
                        //   this.custerInfo.custNickName = res.data.data.custNickName;
                        //   this.custerInfo.custHeadImg = res.data.data.custHeadImg;
                        // }
                        // if (this.currentPage === 0) {
                        //   this.getMessageList(true, true);
                        // }
                        _this8.isOver = false;
                        if (mes.type === 'TIMCustomElem') {
                          // 格式化自定义消息
                          // eslint-disable-next-line no-param-reassign
                          mes.flow = 'date';
                        } else if (mes.type === 'TIMImageElem') {
                          // 格式化图片消息
                          url = mes.payload.imageInfoArray[0].imageUrl.split('?imageView')[0]; // eslint-disable-next-line no-param-reassign
                          mes.payload = {
                            text: "<img class=\"tim-pic\" z-src=\"".concat(url, "\" islazy=\"1\" src=\"").concat(require('@/assets/images/default-img.png'), "\">")
                          };
                        } else if (mes.type !== 'TIMImageElem') {
                          // 解析表情转本地库表情
                          for (j = 0; j < _this8.emojiList.length; j += 1) {
                            reg = new RegExp(_this8.emojiList[j].code, 'g'); // eslint-disable-next-line no-param-reassign
                            mes.payload.text = utf16toEntities(mes.payload.text).replace(reg, "<img class=\"emoji-img\" src=\"".concat(_this8.emojiList[j].src, "\">"));
                          }
                        }
                        // for (let i = 0; i < this.messageList.length; i += 1) {
                        //   if (this.messageList[i].payload.text === '会话转接中...') {
                        //     this.messageList[i].payload.text = '会话转接成功';
                        //     break;
                        //   }
                        // }
                        if (mes.payload.description === 'goodsInfo') {
                          // 格式化自定义消息
                          goodsData = JSON.parse(mes.payload.data); // eslint-disable-next-line no-param-reassign
                          mes.payload = goodsData;
                          // eslint-disable-next-line no-param-reassign
                          mes.type = 'goodsInfo';
                          // eslint-disable-next-line no-param-reassign
                          mes.flow = 'in';
                        }
                        _this8.messageList.push(mes);
                        setTimeout(function () {
                          var timPics = document.querySelectorAll('.tim-pic');
                          timPics.forEach(function (element) {
                            // eslint-disable-next-line no-shadow
                            if (element.getAttribute('islazy') === '1') {
                              element.setAttribute('islazy', 0);
                              element.setAttribute('src', element.getAttribute('z-src'));
                            }
                            element.addEventListener('click', function (e) {
                              _this8.showImg = true;
                              // eslint-disable-next-line prefer-destructuring
                              _this8.imgSrc = e.currentTarget.src.split('?imageView')[0];
                            });
                          });
                        }, 0);
                      case 31:
                        _this8.$nextTick(function () {
                          setTimeout(function () {
                            if (_this8.$refs.content) {
                              ;
                              _this8.$refs.content.scrollTop = _this8.$refs.content.scrollHeight - _this8.$refs.content.clientHeight;
                            } // 滚动条位置设置在底部
                          }, 300);
                        });
                      case 32:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }));
                return function (_x2) {
                  return _ref.apply(this, arguments);
                };
              }());
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function MESSAGE_RECEIVED(_x) {
        return _MESSAGE_RECEIVED.apply(this, arguments);
      }
      return MESSAGE_RECEIVED;
    }()
  }, {
    key: "closeIm",
    value: function closeIm() {
      this.$emit('closeIm');
    }
    // 发送图片消息
  }, {
    key: "sendImageMessage",
    value: function () {
      var _sendImageMessage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3(e) {
        var _this9 = this;
        var file, url, mes, message, promise;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              file = e.target.files[0];
              if (!(file.size / 1024 > 1024 * 10)) {
                _context3.next = 5;
                break;
              }
              ;
              this.$toast.text('图片大小不能超过 10M');
              return _context3.abrupt("return");
            case 5:
              url = window.URL.createObjectURL(file);
              mes = {
                flow: 'out',
                type: 'TIMImageElem',
                payload: {
                  text: "<img class=\"tim-pic\"  src=\"".concat(url, "\" islazy=\"0\" >")
                }
              }; // mes.payload = { text: `<img class="tim-pic"  z-src="${url}" islazy="1" src="${require('@/assets/images/default-img.png')}">` };
              this.messageList.push(mes);
              setTimeout(function () {
                ;
                _this9.$refs.content.scrollTop = _this9.$refs.content.scrollHeight + _this9.$refs.content.clientHeight;
              }, 100);
              // 1. 创建消息实例，接口返回的实例可以上屏
              message = this.tim.createImageMessage({
                to: this.conversationInfo.userProfile.userID,
                conversationType: TIM.TYPES.CONV_C2C,
                payload: {
                  file: file
                }
              }); // 2. 发送图片消息
              promise = this.tim.sendMessage(message);
              promise.then(function () {
                // 发送成功-->格式化图片消息
                // const mes = imResponse.data.message;
                // const url = mes.payload.imageInfoArray[0].imageUrl.split(
                //   '?imageView'
                // )[0];
                // mes.payload = { text: `<img class="tim-pic"  z-src="${url}" islazy="1" src="${require('@/assets/images/default-img.png')}">` };
                // this.messageList.push(mes);
                // setTimeout(() => {
                //   const timPics = document.querySelectorAll('.tim-pic');
                //   timPics.forEach((element:any) => {
                //     if (element.getAttribute('islazy') === '1') {
                //       element.setAttribute('src', element.getAttribute('z-src'));
                //     }
                //     // eslint-disable-next-line no-shadow
                //     element.addEventListener('click', (e:any) => {
                //       this.showImg = true;
                //       // eslint-disable-next-line prefer-destructuring
                //       this.imgSrc = e.currentTarget.src.split('?imageView')[0];
                //     });
                //   });
                // }, 0);
                // setTimeout(() => {
                //   (this.$refs
                //     .content as any).scrollTop = (this as any).$refs.content.scrollHeight;
                // }, 0);
              }).catch(function () {}); // 发送失败
              if (this.$refs.imgFile) this.$refs.imgFile.value = '';
            case 13:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function sendImageMessage(_x3) {
        return _sendImageMessage.apply(this, arguments);
      }
      return sendImageMessage;
    }()
  }, {
    key: "handleKeyCodeUp",
    value: function handleKeyCodeUp() {
      if (this.$refs.message.innerHTML.length > 0) {
        this.isCoding = true;
      } else {
        this.isCoding = false;
      }
      this.getEndRange();
      // if (event.ctrlKey && event.keyCode == 86) {
      // // 粘贴过滤非img为emoji图片以外所有标签
      // const regImg = /!<[^>]*>/g
      // // const regImg = /<[img].*?src=[\'|\"]((?!img\/).*?(?:[\.png]))[\'|\"].*?[\/]?>/ig
      // this.$refs.message.innerHTML = this.$refs.message.innerText
      // }
    }
  }, {
    key: "pasteVal",
    value: function pasteVal() {}
    // 获取输入框最后光标位置
  }, {
    key: "getEndRange",
    value: function getEndRange() {
      if (this.$refs.message.innerHTML.length <= 0) {
        this.isCoding = false;
      }
      this.lastEditRange = window.getSelection().getRangeAt(0);
    }
    // 跳转商品详情
  }, {
    key: "toDetailUrl",
    value: function toDetailUrl(id) {
      window.open("/details?id=".concat(id), '_blank');
    }
    // 发送消息键盘监听（按Enter键发送，按Ctrl+Enter键换行）
  }, {
    key: "handleKeyCodeDown",
    value: function handleKeyCodeDown(event) {
      if (event.ctrlKey && event.keyCode === 13) {
        this.setRange('<br><br>');
      } else if (event.keyCode === 13) {
        this.message = this.$refs.message.innerHTML;
        this.sendMessage();
        event.preventDefault();
      }
    }
    // 在当前光标后添加内容
  }, {
    key: "setRange",
    value: function setRange(html) {
      var el = this.$refs.message;
      var range;
      var node;
      if (!el.hasfocus) el.focus(); // 输入框获取焦点
      if (window.getSelection && window.getSelection().getRangeAt) {
        range = this.lastEditRange ? this.lastEditRange : window.getSelection().getRangeAt(0);
        range.collapse(false);
        node = range.createContextualFragment(html);
        var c = node.lastChild;
        range.insertNode(node);
        if (c) {
          range.setEndAfter(c);
          range.setStartAfter(c);
        }
        var j = window.getSelection();
        j.removeAllRanges();
        j.addRange(range);
      } else if (document.selection && document.selection.createRange) {
        ;
        document.selection.createRange().pasteHTML(html);
      }
    }
  }, {
    key: "inputDiv",
    value: function () {
      var _inputDiv = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4(e) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (e.inputType === 'insertParagraph') {
                this.sendMessage();
              }
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function inputDiv(_x4) {
        return _inputDiv.apply(this, arguments);
      }
      return inputDiv;
    }() // 收到离线消息和会话列表同步完毕通知，接入侧可以调用 sendMessage 等需要鉴权的接口
  }, {
    key: "SDK_READY",
    value: function SDK_READY() {
      var _this10 = this;
      if (this.ready) return;
      this.ready = true; // 同步完毕-->获取最新会话列表
      setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var res, service;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return validateStatus({
                companyId: 1
              });
            case 2:
              res = _context5.sent;
              if (!(res && res.data && res.data.code === 100 && res.data.data.messageStatus)) {
                _context5.next = 10;
                break;
              }
              _context5.next = 6;
              return indexLoad({
                companyId: 1
              });
            case 6:
              service = _context5.sent;
              if (service && service.data && service.data.code === 100 && service.data.data) {
                if (service.data.data) {
                  // 当前有客服在线
                  _this10.custerInfo.conversationID = "C2C".concat(service.data.data.custAccount);
                  _this10.custerInfo.custNickName = service.data.data.custNickName;
                  _this10.custerInfo.custHeadImg = service.data.data.custHeadImg;
                  _this10.conversationInfo = {
                    conversationID: "C2C".concat(service.data.data.custAccount),
                    userProfile: {
                      userID: service.data.data.custAccount
                    }
                  };
                  // 根据客服信息筛选出对应会话列表
                  // eslint-disable-next-line prefer-destructuring
                  // this.conversationInfo = this.conversationList.filter(
                  //   e => e.conversationID === this.custerInfo.conversationID,
                  // )[0];
                  if (_this10.conversationInfo.conversationID) {
                    _this10.getMessageList(false);
                  } // 获取消息列表
                  _this10.isOver = false;
                }
              }
              _context5.next = 11;
              break;
            case 10:
              if (res && res.data && res.data.code === 100 && !res.data.data.messageStatus) {
                // 在会话中，获取客服信息
                _this10.custerInfo.conversationID = "C2C".concat(res.data.data.custAccount);
                _this10.custerInfo.custNickName = res.data.data.custNickName;
                _this10.custerInfo.custHeadImg = res.data.data.custHeadImg;
                _this10.conversationInfo.conversationID = "C2C".concat(res.data.data.custAccount);
                _this10.conversationInfo.userProfile = {
                  userID: res.data.data.custAccount
                };
                // 根据客服信息筛选出对应会话列表
                // eslint-disable-next-line prefer-destructuring
                // this.conversationInfo = this.conversationList.filter(e => e.conversationID === this.custerInfo.conversationID)[0];
                if (_this10.conversationInfo.conversationID) {
                  _this10.getMessageList(false); // 获取消息列表
                  _this10.isOver = false;
                }
              }
            case 11:
              _this10.loading = false;
            case 12:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      })), 200);
    }
  }, {
    key: "getCusterInfo",
    value: function () {
      var _getCusterInfo = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var res;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return custerInfo({
                custAccount: this.conversationInfo.userProfile.userID
              });
            case 2:
              res = _context6.sent;
              if (res && res.data && res.data.code === 100 && res.data.data) {
                res.data.data.custNickName = res.data.data.custer.workNo;
                res.data.data.custHeadImg = res.data.data.faceUrlImg;
                this.custerInfo = res.data.data;
              }
            case 4:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getCusterInfo() {
        return _getCusterInfo.apply(this, arguments);
      }
      return getCusterInfo;
    }()
    /**
     * 格式化列表（自定义、图片、表情）
     * @list 格式化的列表
     * @insert 数组函数（push、unshift）
     */
  }, {
    key: "formatList",
    value: function formatList(list, insert) {
      var newList = [];
      var tempList = list;
      for (var i = 0; i < list.length; i += 1) {
        if (tempList[i].type === 'TIMCustomElem' && list[i].payload.data && list[i].payload.description !== 'goodsInfo') {
          // 格式化自定义消息
          var data = JSON.parse(list[i].payload.data);
          if (data.itemType === 7 || data.itemType === 0 || data.itemType === 1 || data.itemType === -1) {
            if (data.itemType === -1) {
              tempList[i].flow = 'in';
            }
            this.isOver = true;
          } else {
            tempList[i].flow = 'status';
          }
          var text = '';
          if (data.itemType === -1) {
            text = JSON.parse(tempList[i].payload.data);
            tempList[i].type = -1;
            tempList[i].payload = text;
          } else if (data.itemData && data.itemData.length > 0) {
            if (list[i].flow === 'out') {
              text = data.itemData[0].itemTitle;
            } else {
              text = data.itemData[0].itemValue;
            }
          } else {
            text = data.itemText;
          }
          if (data.itemType !== -1) {
            tempList[i].payload = {
              text: text
            };
          }
        } else if (list[i].payload.description === 'goodsInfo') {
          // 格式化自定义消息
          var _text = JSON.parse(list[i].payload.data);
          // eslint-disable-next-line no-param-reassign
          tempList[i].payload = _text;
          tempList[i].type = 'goodsInfo';
          // eslint-disable-next-line no-param-reassign
          tempList[i].flow = list[i].flow;
        } else if (tempList[i].type === 'TIMImageElem') {
          // 格式化图片消息
          var url = tempList[i].payload.imageInfoArray ? tempList[i].payload.imageInfoArray[0].imageUrl : tempList[i].payload.text;
          // eslint-disable-next-line no-param-reassign
          // eslint-disable-next-line prefer-destructuring
          tempList[i].payload.text = "<img class=\"tim-pic\"  z-src=\"".concat(url, "\" islazy=\"1\" src=\"").concat(require('@/assets/images/default-img.png'), "\">");
        }
        // 解析表情转本地库表情
        if (list[i].type !== 'TIMImageElem') {
          for (var j = 0; j < this.emojiList.length; j += 1) {
            var reg = new RegExp(this.emojiList[j].code, 'g');
            // eslint-disable-next-line no-param-reassign
            // eslint-disable-next-line import/no-dynamic-require
            tempList[i].payload.text = utf16toEntities(tempList[i].payload.text).replace(reg, "<img class=\"emoji-img\" src=\"".concat(this.emojiList[j].src, "\">"));
          }
        }
        newList[insert](tempList[i]);
      }
      return newList;
    }
    /**
     * 格式化列表（自定义、图片、表情）
     * @list 格式化的列表
     * @insert 数组函数（push、unshift）
     */
  }, {
    key: "formatHistoryList",
    value: function formatHistoryList(list, insert) {
      var newList = [];
      var tempList = list;
      for (var i = 0; i < list.length; i += 1) {
        if (tempList[i].type === 'TIMCustomElem' && list[i].payload.data && list[i].payload.description !== 'goodsInfo') {
          // 格式化自定义消息
          var text = JSON.parse(list[i].payload.data).itemText;
          // eslint-disable-next-line no-param-reassign
          tempList[i].payload = {
            text: text
          };
          // eslint-disable-next-line no-param-reassign
          tempList[i].flow = 'status';
        } else if (list[i].payload.description === 'goodsInfo') {
          // 格式化自定义消息
          var _text2 = JSON.parse(list[i].payload.data);
          // eslint-disable-next-line no-param-reassign
          tempList[i].payload = {
            text: _text2
          };
          tempList[i].type = 'goodsInfo';
          // eslint-disable-next-line no-param-reassign
          tempList[i].flow = 'status';
        } else if (tempList[i].type === 'TIMImageElem') {
          // 格式化图片消息
          var url = tempList[i].payload.text;
          // eslint-disable-next-line no-param-reassign
          // eslint-disable-next-line prefer-destructuring
          tempList[i].payload.text = "<img class=\"tim-pic\" z-src=\"".concat(url, "\" islazy=\"1\" src=\"").concat(require('@/assets/images/default-img.png'), "\">");
        }
        // 解析表情转本地库表情
        if (list[i].type !== 'TIMImageElem') {
          for (var j = 0; j < this.emojiList.length; j += 1) {
            var reg = new RegExp(this.emojiList[j].code, 'g');
            // eslint-disable-next-line no-param-reassign
            // eslint-disable-next-line import/no-dynamic-require
            tempList[i].payload.text = utf16toEntities(tempList[i].payload.text).replace(reg, "<img class=\"emoji-img\" src=\"".concat(this.emojiList[j].src, "\">"));
          }
        }
        newList[insert](tempList[i]);
      }
      return newList;
    }
    // 判断是否获取焦点
  }, {
    key: "calcInput",
    value: function () {
      var _calcInput = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              this.isCoding = true;
            case 1:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function calcInput() {
        return _calcInput.apply(this, arguments);
      }
      return calcInput;
    }() // 向上滚动获取更多消息列表
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this11 = this;
        var res, list;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!this.isDrop) {
                _context8.next = 2;
                break;
              }
              return _context8.abrupt("return");
            case 2:
              if (!(this.$refs.content.scrollHeight <= this.$refs.content.clientHeight)) {
                _context8.next = 4;
                break;
              }
              return _context8.abrupt("return");
            case 4:
              if (!(this.isMoreMessage && this.$refs.content.scrollTop === 0)) {
                _context8.next = 11;
                break;
              }
              this.scrollHeight = this.$refs.content.scrollHeight;
              _context8.next = 8;
              return this.tim.getMessageList({
                conversationID: this.conversationInfo.conversationID,
                nextReqMessageID: this.nextReqMessageID,
                count: 15
              });
            case 8:
              res = _context8.sent;
              if (res && res.code === 0 && res.data) {
                this.currentPage = res.data.nextReqMessageID.split('-')[res.data.nextReqMessageID.split('-').length - 1];
                this.nextReqMessageID = res.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段
                this.isMoreMessage = !res.data.isCompleted; // 表示是否已经拉完所有消息
                list = [];
                res.data.messageList.forEach(function (item) {
                  list.unshift(item);
                });
                this.messageList = this.formatList(list, 'unshift').concat(this.messageList);
                setTimeout(function () {
                  var timPics = document.querySelectorAll('.tim-pic');
                  timPics.forEach(function (element) {
                    if (element.getAttribute('islazy') === '1') {
                      element.setAttribute('src', element.getAttribute('z-src'));
                    }
                    // eslint-disable-next-line no-shadow
                    element.addEventListener('click', function (e) {
                      _this11.showImg = true;
                      // eslint-disable-next-line prefer-destructuring
                      _this11.imgSrc = e.currentTarget.src.split('?imageView')[0];
                    });
                  });
                }, 0);
              }
              this.$nextTick(function () {
                ;
                _this11.$refs.content.scrollTop = _this11.$refs.content.scrollHeight - _this11.scrollHeight;
                _this11.scrollHeight = _this11.$refs.content.scrollHeight;
              });
            case 11:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }() // 获取消息列表
  }, {
    key: "getMessageList",
    value: function () {
      var _getMessageList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9(isFlag) {
        var _this12 = this;
        var res;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return this.tim.getMessageList({
                conversationID: this.conversationInfo.conversationID,
                count: 15
              });
            case 2:
              res = _context9.sent;
              if (res && res.code === 0 && res.data) {
                // if (this.conversationInfo.conversationID === 'C2Cadmin' || this.conversationInfo.conversationID === 'C2CmallAdmin') {
                //   this.loading = false;
                //   const list = res.data.messageList[res.data.messageList.length - 1];
                //   this.isMoreMessage = true;
                //   this.messageList = this.formatList([list], 'push');
                //   (this as any).$refs.message.innerHTML = '';
                //   this.isOver = true;
                //   // setTimeout(() => {
                //   //   this.tim.logout();
                //   // }, 2000);
                //   return;
                // }
                this.isOver = false;
                // eslint-disable-next-line radix
                this.nextReqMessageID = res.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段
                this.isMoreMessage = !res.data.isCompleted; // 表示是否已经拉完所有消息
                if (res.data.messageList.length > 0) {
                  this.messageList = this.formatList(res.data.messageList, 'push');
                  this.$forceUpdate();
                }
                if (isFlag) {
                  this.messageList.push({
                    payload: {
                      text: '会话转接成功'
                    },
                    flow: 'status'
                  });
                }
                // if (this.robotObj.type === -1 && !this.changeIm) {
                //   this.messageList.push(this.robotObj);
                // }
                this.$nextTick(function () {
                  setTimeout(function () {
                    // eslint-disable-next-line no-unused-vars
                    var tempDom = document.querySelector('.im-content');
                    tempDom.scrollTop = tempDom.scrollHeight + tempDom.clientHeight; // 滚动条位置设置在底部
                  }, 301);
                });
                // this.currentLen = this.messageList.length;
                this.messageList.push({
                  payload: {
                    text: ''
                  },
                  type: 'isGoods'
                });
                this.currentPage += 1;
                setTimeout(function () {
                  var timPics = document.querySelectorAll('.tim-pic');
                  timPics.forEach(function (element) {
                    if (element.getAttribute('islazy') === '1') {
                      element.setAttribute('src', element.getAttribute('z-src'));
                    }
                    element.addEventListener('click', function (e) {
                      _this12.showImg = true;
                      // eslint-disable-next-line prefer-destructuring
                      _this12.imgSrc = e.currentTarget.src.split('?imageView')[0];
                    });
                  });
                }, 0);
                this.tim.setMessageRead({
                  conversationID: this.conversationInfo.conversationID
                }); // 设置已读
              }
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getMessageList(_x5) {
        return _getMessageList.apply(this, arguments);
      }
      return getMessageList;
    }() // // 获取消息列表
    // async getMessageList() {
    //   const res = await this.tim.getMessageList({
    //     conversationID: this.conversationInfo.conversationID,
    //     count: 15
    //   });
    //   if (res && res.code === 0 && res.data) {
    //     this.nextReqMessageID = res.data.nextReqMessageID; // 用于续拉，分页续拉时需传入该字段
    //     this.isMoreMessage = !res.data.isCompleted; // 表示是否已经拉完所有消息
    //     this.messageList = res.data.messageList.map((item: any) => {
    //       const data = item;
    //       if (data.type === 'TIMCustomElem') {
    //         const text = JSON.parse(data.payload.data).itemText;
    //         data.payload = { text };
    //         data.flow = 'status';
    //       }
    //       return data;
    //     });
    //     // utf16toEntities(item.lastMessage.messageForShow).replace(reg, `<img src="${this.emojiList[i].src}">`)
    //     // this.messageList = this.formatList(res.data.messageList, 'push'); // 获取当前消息列表
    //     this.tim.setMessageRead({
    //       conversationID: this.conversationInfo.conversationID
    //     }); // 设置已读
    //   }
    // }
    // 收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面
  }, {
    key: "CONVERSATION_LIST_UPDATED",
    value: function CONVERSATION_LIST_UPDATED(event) {
      var _this13 = this;
      // if (this.ready && event.data.length > 0) {
      //   this.conversationList = event.data; // 获取所有会话列表
      //   this.ready = false;
      // }
      var data = event.data[0];
      // eslint-disable-next-line no-shadow
      this.conversationInfo = data;
      setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var mes, temp;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(data && data.lastMessage && data.lastMessage.payload.data && (JSON.parse(data.lastMessage.payload.data).itemType === 1 || JSON.parse(data.lastMessage.payload.data).itemType === 0))) {
                _context10.next = 3;
                break;
              }
              _context10.next = 26;
              break;
            case 3:
              if (!(data && data.lastMessage && data.lastMessage.payload.data && JSON.parse(data.lastMessage.payload.data).itemType !== 4 && JSON.parse(data.lastMessage.payload.data).itemType !== 5)) {
                _context10.next = 25;
                break;
              }
              // await this.getMessageList(false, false);
              mes = event.data[0];
              if (!mes.lastMessage.payload.data) {
                _context10.next = 20;
                break;
              }
              if (!(_this13.currentId === JSON.parse(data.lastMessage.payload.data).itemType)) {
                _context10.next = 8;
                break;
              }
              return _context10.abrupt("return");
            case 8:
              _this13.currentId = JSON.parse(data.lastMessage.payload.data).itemType;
              // eslint-disable-next-line prefer-destructuring
              temp = JSON.parse(mes.lastMessage.payload.data);
              temp.payload = {
                text: temp.itemText
              };
              temp.flow = 'status';
              if (!(_this13.messageList.length > 0)) {
                _context10.next = 19;
                break;
              }
              if (!(_this13.newTime === temp.time)) {
                _context10.next = 15;
                break;
              }
              return _context10.abrupt("return");
            case 15:
              _this13.messageList = [];
              _this13.messageList.push(temp);
              _context10.next = 20;
              break;
            case 19:
              if (JSON.parse(data.lastMessage.payload.data).itemType === 7) {
                _this13.messageList.push(temp);
              }
            case 20:
              _this13.currentPage = 0;
              _this13.isOver = true;
              setTimeout(function () {
                _this13.currentId = -1;
              }, 1000);
              // this.getMessageList();
              _context10.next = 26;
              break;
            case 25:
              // if (this.currentPage === 0 && event.data[0].conversationID !== 'C2Cadmin') {
              //   // eslint-disable-next-line prefer-destructuring
              //   this.conversationInfo = event.data[0];
              //   await this.getCusterInfo();
              //   // alert('1');
              //   await this.getMessageList(true, false);
              //   const goods: any = {};
              //   goods.flow = 'consult';
              //   goods.payload = Object.assign({}, this.productInfo);
              //   this.messageList.push(goods);
              // }
              // eslint-disable-next-line no-lonely-if
              if (data && data.lastMessage && data.lastMessage.payload.data && JSON.parse(data.lastMessage.payload.data).itemType === 6) {
                _this13.isOver = true;
              } else {
                _this13.isOver = false;
              }
            case 26:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      })), 0);
    }
    // CONVERSATION_LIST_UPDATED(event : any) {
    //   const robot = event.data.filter((e: any) => e.conversationID === 'C2Cadmin');
    //   // if (robot.length === 1) this.robot = JSON.parse(robot[0].lastMessage.payload.data);
    //   // eslint-disable-next-line prefer-destructuring
    //   // if (event.data[0].conversationID !== 'C2Cadmin') this.conversationInfo = event.data[0];
    //   // // eslint-disable-next-line prefer-destructuring
    //   // else this.conversationInfo = event.data[1];
    //   // eslint-disable-next-line prefer-destructuring
    //   setTimeout(() => {
    //     if (robot[0].lastMessage.payload.data && JSON.parse(robot[0].lastMessage.payload.data).itemType !== 4 && JSON.parse(robot[0].lastMessage.payload.data).itemType !== 5) {
    //       // eslint-disable-next-line prefer-destructuring
    //       this.conversationInfo = robot[0];
    //       this.getMessageList();
    //       this.isOver = true;
    //     // this.getMessageList();
    //     } else {
    //       validateStatus({}).then((res : any) => {
    //         this.conversationInfo = {
    //           conversationID: `C2C${res.data.data.custAccount}`,
    //           userProfile: { userID: res.data.data.custAccount }
    //         };
    //         this.getCusterInfo();
    //         if (this.currentPage === 0) { this.getMessageList(); }
    //       });
    //       // alert(123);
    //       // validateStatus({}).then((res : any) => {
    //       //   this.conversationInfo = {
    //       //     conversationID: `C2C${res.data.data.custAccount}`,
    //       //     userProfile: { userID: res.data.data.custAccount }
    //       //   };
    //       //   this.getMessageList();
    //       // });
    //       this.isOver = false;
    //     }
    //   }, 100);
    // }
    // CONVERSATION_LIST_UPDATED(event: any) {
    //   if (event.data[0].lastMessage.payload.data && JSON.parse(event.data[0].lastMessage.payload.data).itemType === 7) {
    //     this.custerInfo.tempName = event.data[0].userProfile.nick;
    //     this.messageList.push({ type: 'TIMCustomElem', payload: { text: JSON.parse(event.data[0].lastMessage.payload.data).itemText }, flow: 'in' });
    //     this.isOver = false;
    //     return;
    //     // this.outLogin();
    //     // eslint-disable-next-line no-param-reassign
    //   }
    //   this.isOver = true;
    //   // else if (event.data[0].lastMessage.payload.data && JSON.parse(event.data[0].lastMessage.payload.data).itemType === 6) {
    //   //   this.messageList.push({ type: 'TIMCustomElem', payload: { text: JSON.parse(event.data[0].lastMessage.payload.data).itemText }, flow: 'status' });
    //   //   // eslint-disable-next-line no-param-reassign
    //   // }
    //   const robot = event.data.filter((e: any) => e.conversationID === 'C2Cadmin');
    //   if (robot.length === 1) {
    //     this.robot = JSON.parse(robot[0].lastMessage.payload.data);
    //   }
    //   if (event.data[0].conversationID !== 'C2Cadmin') {
    //     // eslint-disable-next-line prefer-destructuring
    //     this.conversationInfo = event.data[0];
    //   } else {
    //     // eslint-disable-next-line prefer-destructuring
    //     this.conversationInfo = event.data[1];
    //   }
    // }
    // // 收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面
    // CONVERSATION_LIST_UPDATED(event : any) {
    //   const robot = event.data.filter((e: any) => e.conversationID === 'C2Cadmin');
    //   if (robot.length === 1) this.robot = JSON.parse(robot[0].lastMessage.payload.data);
    //   // eslint-disable-next-line prefer-destructuring
    //   if (event.data[0].conversationID !== 'C2Cadmin') { this.conversationInfo = event.data[0]; } else this.conversationInfo = event.data[1];
    // }
    // 账号导入
  }, {
    key: "outLogin",
    value: function () {
      var _outLogin = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var promise;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              promise = this.tim.logout();
              _context11.next = 3;
              return promise.then(function () {}).catch(function () {});
            case 3:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function outLogin() {
        return _outLogin.apply(this, arguments);
      }
      return outLogin;
    }()
  }, {
    key: "getImportAccount",
    value: function () {
      var _getImportAccount = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee12() {
        var anchor, res;
        return _regeneratorRuntime().wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              anchor = readCookie('anchor');
              _context12.next = 3;
              return importAccount({
                headImgType: anchor ? '5_im' : '7_im',
                companyId: 1,
                model: anchor ? anchor.model : '',
                equipVersion: anchor ? anchor.equipVersion : '',
                equipMeid: anchor ? anchor.equipMeid : ''
              });
            case 3:
              res = _context12.sent;
              this.userInfo = res.data.data;
              this.getValidateStatus();
            case 6:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function getImportAccount() {
        return _getImportAccount.apply(this, arguments);
      }
      return getImportAccount;
    }() // 将dom对象转换成字符串
  }, {
    key: "nodeToString",
    value: function nodeToString(node) {
      // createElement()返回一个Element对象
      var tmpNode = document.createElement('div');
      // appendChild()  参数Node对象   返回Node对象  Element方法
      // cloneNode()  参数布尔类型  返回Node对象   Element方法
      tmpNode.appendChild(node.cloneNode(true));
      var str = tmpNode.innerHTML;
      return str;
    }
    // 会话状态
  }, {
    key: "sessionState",
    value: function () {
      var _sessionState = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee13() {
        var _this14 = this;
        var state, promise;
        return _regeneratorRuntime().wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.next = 2;
              return validateInputStatus({
                companyId: 1
              });
            case 2:
              state = _context13.sent;
              if (!(state && state.code === 100 && state.data && state.data.data.messageStatus)) {
                _context13.next = 5;
                break;
              }
              return _context13.abrupt("return", true);
            case 5:
              promise = this.tim.deleteConversation(this.conversationInfo.conversationID);
              promise.then(function () {
                // (this as any).$toast.text('当前会话已结束');
                _this14.$message.error('当前会话已结束');
                _this14.isOver = true;
              });
              return _context13.abrupt("return", false);
            case 8:
            case "end":
              return _context13.stop();
          }
        }, _callee13, this);
      }));
      function sessionState() {
        return _sessionState.apply(this, arguments);
      }
      return sessionState;
    }() // // 发送消息
    // sendMessage() {
    //   // 1. 创建消息实例，接口返回的实例可以上屏
    //   const lastTime = this.messageList.length >= 1 ? this.messageList[this.messageList.length - 1].time : 0; // 最后一条消息的时间
    //   const d: any = new Date();
    //   const date: any = Date.parse(d) / 1000;
    //   // eslint-disable-next-line radix
    //   const realTime = parseInt(date);
    //   // 时间大于5分钟则验证会话状态
    //   if ((realTime - lastTime) >= 300) {
    //     const state = this.sessionState();
    //     if (!state) return;
    //   }
    //   this.message = (this.$refs.message as any).innerHTML;
    //   if (this.message.indexOf('data-src="emoji"') !== -1) {
    //     for (let i = 0; i < this.emojis.length; i += 1) {
    //       if (this.message.indexOf(`${this.emojis[i].text}`) !== -1) {
    //         const dom = (this.$refs.message as any).querySelector(`img[emoji-text=${this.emojis[i].text}]`);
    //         // (this.$refs.message as any).removeChild(dom);
    //         // const regImg = new RegExp(`<img class="emoji-img" emoji-src="${this.emojis[i].src}" data-src="emoji">`, 'g');
    //         this.message = this.message.replace(this.nodeToString(dom), uncodeUtf16(this.emojis[i].code));
    //         if (this.message.indexOf('data-src="emoji"') === -1) break;
    //       }
    //     }
    //   }
    //   const initMessage = this.tim.createTextMessage({
    //     to: this.conversationInfo.userProfile.userID,
    //     conversationType: TIM.TYPES.CONV_C2C,
    //     // payload: {
    //     //   text: `json=${JSON.stringify({
    //     //     name: '输入佳博P3热敏不干胶条码打印机佳博',
    //     //     url: 'https://6d84-shanghai-007-shared-09-1256635546.cos.ap-shanghai.myqcloud.com/a6ec-1400428151/4353-mall_im_96295/mall_im_96295-CT002-2523-logo.png',
    //     //     price: 11.22
    //     //   })}`
    //     // }
    //     payload: { text: this.message }
    //   });
    //   // 2. 发送消息
    //   const promise = this.tim.sendMessage(initMessage);
    //   promise
    //     .then((imResponse: any) => {
    //       this.messageList.push(imResponse.data.message); // 更新消息列表
    //     })
    //     .catch((imError: any) => {
    //     }); // 发送失败
    // }
    // 发送文字或表情消息
  }, {
    key: "sendMessage",
    value: function () {
      var _sendMessage = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee14() {
        var _this15 = this;
        var reg, mes, _loop, i, initMessage, promise;
        return _regeneratorRuntime().wrap(function _callee14$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              if (!this.isOver) {
                _context15.next = 2;
                break;
              }
              return _context15.abrupt("return");
            case 2:
              // const lastTime = this.messageList.length >= 1
              //   ? this.messageList[this.messageList.length - 1].time
              //   : 0; // 最后一条消息的时间
              // const d: any = new Date();
              // const date: any = Date.parse(d) / 1000;
              // eslint-disable-next-line radix
              // const realTime = parseInt(date);
              // 时间大于5分钟则验证会话状态
              reg = /\S/g;
              if (reg.test(this.$refs.message.innerHTML.replace('<br>', ''))) {
                _context15.next = 8;
                break;
              }
              ;
              this.$refs.message.focus();
              this.$toast.text('不能发送空白消息');
              return _context15.abrupt("return");
            case 8:
              // if (realTime - lastTime >= 300) {
              //   const state = await this.sessionState();
              //   if (!state) return;
              // }
              mes = this.$refs.message.innerHTML.replace(/\n/g, '<br>'); // 表情解码发送
              this.message = this.$refs.message.innerHTML.replace(/\n/g, '<br>');
              if (!(this.message.indexOf('data-src="emoji"') !== -1)) {
                _context15.next = 20;
                break;
              }
              _loop = /*#__PURE__*/_regeneratorRuntime().mark(function _loop(i) {
                var doms;
                return _regeneratorRuntime().wrap(function _loop$(_context14) {
                  while (1) switch (_context14.prev = _context14.next) {
                    case 0:
                      if (!(_this15.message.indexOf("".concat(_this15.emojis[i].src)) !== -1)) {
                        _context14.next = 5;
                        break;
                      }
                      doms = _this15.$refs.message.querySelectorAll("img[emoji-text=".concat(_this15.emojis[i].text, "]")); // (this.$refs.message as any).removeChild(dom);
                      // const regImg = new RegExp(`<img class="emoji-img" emoji-src="${this.emojis[i].src}" data-src="emoji">`, 'g');
                      doms.forEach(function (element) {
                        _this15.message = _this15.message.replace(_this15.nodeToString(element), uncodeUtf16(_this15.emojis[i].code));
                      });
                      if (!(_this15.message.indexOf('data-src="emoji"') === -1)) {
                        _context14.next = 5;
                        break;
                      }
                      return _context14.abrupt("return", 1);
                    case 5:
                    case "end":
                      return _context14.stop();
                  }
                }, _loop);
              });
              i = 0;
            case 13:
              if (!(i < this.emojis.length)) {
                _context15.next = 20;
                break;
              }
              return _context15.delegateYield(_loop(i), "t0", 15);
            case 15:
              if (!_context15.t0) {
                _context15.next = 17;
                break;
              }
              return _context15.abrupt("break", 20);
            case 17:
              i += 1;
              _context15.next = 13;
              break;
            case 20:
              ;
              this.$refs.message.innerHTML = '';
              // 1. 创建消息实例，接口返回的实例可以上屏
              initMessage = this.tim.createTextMessage({
                to: this.conversationInfo.userProfile.userID,
                conversationType: TIM.TYPES.CONV_C2C,
                payload: {
                  text: this.message
                }
              }); // 2. 发送消息
              promise = this.tim.sendMessage(initMessage);
              promise.then(function (imResponse) {
                // eslint-disable-next-line no-param-reassign
                imResponse.data.message.payload.text = mes;
                _this15.messageList.push(imResponse.data.message); // 更新消息列表
                _this15.message = '';
                _this15.$nextTick(function () {
                  ;
                  _this15.$refs.content.scrollTop = _this15.$refs.content.scrollHeight - _this15.$refs.content.clientHeight; // 滚动条位置设置在底部
                });
              }).catch(function () {}); // 发送失败
            case 25:
            case "end":
              return _context15.stop();
          }
        }, _callee14, this);
      }));
      function sendMessage() {
        return _sendMessage.apply(this, arguments);
      }
      return sendMessage;
    }()
  }, {
    key: "getImData",
    value: function () {
      var _getImData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee15() {
        return _regeneratorRuntime().wrap(function _callee15$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              this.getValidateStatus();
            case 1:
            case "end":
              return _context16.stop();
          }
        }, _callee15, this);
      }));
      function getImData() {
        return _getImData.apply(this, arguments);
      }
      return getImData;
    }()
  }, {
    key: "getValidateStatus",
    value: function () {
      var _getValidateStatus = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee16() {
        var _this16 = this;
        var promise;
        return _regeneratorRuntime().wrap(function _callee16$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return this.initTim();
            case 2:
              this.tim = _context17.sent;
              // this.outLogin();
              promise = this.tim.login({
                userID: this.userInfo.account,
                userSig: this.userInfo.userSign
              });
              promise.then(function (imResponse) {
                if (imResponse.data.repeatLogin === true) {
                  // 标识账号已登录，本次登录操作为重复登录。v2.5.1 起支持
                  _this16.ready = false;
                  _this16.SDK_READY();
                }
              }).catch(function () {});
              // this.getImportAccount();
              // this.getHistory();
            case 5:
            case "end":
              return _context17.stop();
          }
        }, _callee16, this);
      }));
      function getValidateStatus() {
        return _getValidateStatus.apply(this, arguments);
      }
      return getValidateStatus;
    }()
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    bigImg: bigImg
  },
  filters: {
    calcPrice: function calcPrice(val) {
      if (!val) {
        return;
      }
      // eslint-disable-next-line consistent-return
      return val.toString().split('.')[0];
    },
    calcPrice2: function calcPrice2(val) {
      if (!val) {
        return;
      }
      // eslint-disable-next-line consistent-return
      return val.toString().split('.')[1] ? val.toString().split('.')[1] : '00';
    },
    formatDate: function formatDate(time) {
      if (!time) {
        return;
      }
      // eslint-disable-next-line consistent-return
      return moment(time).format('YYYY-MM-DD HH:mm:ss');
    }
  }
})], default_1);
export default default_1;